// import { watch } from 'vue';
// на выходе данные массив обьектов содержашиеся в this.selectedUsers

import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      // selectedUsers: [],
      // selectedUsers_elem: []
    };
  },
  computed: {
    isAllSelected() {
      return this.workers_id.length === this.totalUsersCount();
    },
    ...mapState({
      workers: state => state.modalUsers.workers,
      workers_id: state => state.modalUsers.workers_id
    })
  },
  methods: {
    ...mapMutations({
      SET_WORKERS_ID: 'modalUsers/SET_WORKERS_ID',
      PYSH_WORKERS_ID: 'modalUsers/PYSH_WORKERS_ID',
      SET_WORKERS: 'modalUsers/SET_WORKERS',
      PYSH_WORKERS: 'modalUsers/PYSH_WORKERS',
      FILTER_AND_REMOVE_WORKERS: 'modalUsers/FILTER_AND_REMOVE_WORKERS',
      FILTER_AND_REMOVE_WORKERS_ID: 'modalUsers/FILTER_AND_REMOVE_WORKERS_ID'
    }),
    totalUsersCount() {
      // Вспомогательный метод для получения общего количества пользователей
      return this.users.reduce((total, group) => total + group.length, 0);
    },
    isSelected(userId) {
      // Проверяем, выбран ли пользователь по его айдишнику
      return this.workers_id.includes(Number(userId.user_id));
    },
    selectAll() {
      // Обработчик для выбора всех пользователей
      if (this.isAllSelected) {
        this.SET_WORKERS_ID([]);
        this.SET_WORKERS([]);
      } else {
        const members_id = this.users.reduce(
          (allUsers, group) =>
            allUsers.concat(group.map(user => Number(user.user_id))),
          []
        );
        const members = this.users.reduce(
          (allUsers, group) => allUsers.concat(group.map(user => user)),
          []
        );
        this.SET_WORKERS_ID(members_id);
        this.SET_WORKERS(members);
      }
    },
    isGroupSelected(group) {
      // Проверяем, выбраны ли все пользователи в группе
      return group.every(user =>
        this.workers_id.includes(Number(user.user_id))
      );
    },
    selectGroup(group) {
      // Обработчик для выбора всех пользователей в группе
      if (this.isGroupSelected(group)) {
        const members_id = this.workers_id.filter(
          userId => !group.some(user => Number(user.user_id) === Number(userId))
        );
        const members = this.workers.filter(
          userId =>
            !group.some(user => Number(user.user_id) === Number(userId.user_id))
        );
        this.SET_WORKERS_ID(members_id);
        this.SET_WORKERS(members);
      } else {
        const members_id = this.workers_id.concat(
          group
            .filter(user => !this.workers_id.includes(Number(user.user_id)))
            .map(user => Number(user.user_id))
        );

        const members = this.workers.concat(
          group
            .filter(
              user =>
                !this.workers.some(member => member.user_id === user.user_id)
            )
            .map(user => ({ ...user })) // Копируем объекты для создания новых ссылок
        );

        this.SET_WORKERS_ID(members_id);
        this.SET_WORKERS(members);
      }
    },
    selectUser(userId) {
      // Обработчик для выбора отдельного пользователя
      if (this.isSelected(userId)) {
        this.FILTER_AND_REMOVE_WORKERS(Number(userId.user_id));
        this.FILTER_AND_REMOVE_WORKERS_ID(Number(userId.user_id));
      } else {
        this.PYSH_WORKERS_ID(userId.user_id);
        this.PYSH_WORKERS(userId);
      }
    }
  }
};
